import Notify from "./notify";
import {sendDeleteRequest, sendGetRequest, sendPostRequest} from "./apiv4helper";
import $ from "jquery";
import {default as i18n} from "i18next";

const dim = () => $('body').find('.main-dimmer').addClass('active');

const undim = () => $('body').find('.main-dimmer').removeClass('active');

function updateHTMLWithGireveEmpContract(data) {
    if (data.hasOwnProperty('data') || 'data' in data) {
        data = data.data;
    }
    const body = $('body');
    const activeContractTable = body.find('.active-gireve-cpo-contract-table');

    activeContractTable.find('tbody').empty();
    let nrOfActiveContracts = 0;
    if (data.length) {
        const contract = data[0];
        console.log(contract);
        nrOfActiveContracts += 1;
        const row =
            "<tr>" +
            "<td>" + contract.party_id + "</td>" +
            "<td>" + contract.country_code + "</td>" +
            "<td>" + contract.url + "</td>" +
            "<td>" + contract.business_details.name + "</td>" +
            "<td class='right aligned'><button class='ui small button primary show-gireve-emp-tariff-modal' data-value='" + contract.id + "'>"+ "EMP Tariff" +"</button></td>" +
            "<td class='right aligned'><button class='ui small button red invalidate-gireve-emp-contract' data-value='" + contract.id + "'>"+ i18n.t('Delete') +"</button></td>" +
            "</tr>";
        activeContractTable.find('tbody').append(row);
    }

    if (nrOfActiveContracts > 0) {
        activeContractTable.show();
        $("#register-gireve-emp-component").hide();
    } else {
        activeContractTable.hide();
        $('#register-gireve-emp-component').show();
    }
    undim();
}

const showGireveEmpTab = () => {
    $('body').find('.settings-interface').find('.button').each(function () {
        $(this).removeClass('active');
    });

    $('.cpo-interface').hide();
    $('.emsp-interface').hide();
    $('.gireve-cpo-interface').hide();
    $('.show-gireve-emp').addClass('active');
    $('.gireve-emp-interface').removeClass('hidden');
    $('.gireve-emp-interface').show();
    undim();
}

const loadGireveEMPContract = (sellerId) => {
    dim();
    sendGetRequest('/admin/roaming/gireve/emp/contract/' + sellerId)
        .done((data) => {
            showGireveEmpRegisterComponent();
            updateHTMLWithGireveEmpContract(data);
        })
        .fail((XMLHttpRequest, textStatus, errorMessage) => {
            Notify.error(errorMessage);
            undim();
        });
}

const showGireveEmpRegisterComponent = () => {
    $('#register-gireve-emp-component').show();
    $('#manage-gireve-emp-component').hide();
    $('.gireve-emp-registration-token').val('');
    showGireveEmpTab();
}

const registerInGireveEMPSystem = (token, sellerId) => {
    dim();
    const data = {
        "token": token,
        "is_gireve": true
    };
    sendPostRequest('/admin/roaming/gireve/emp/register/' + sellerId, data)
        .done((response) => {
            showGireveEmpRegisterComponent();
            updateHTMLWithGireveEmpContract(response);
            Notify.success("Gireve EMP registration is successful.");
            undim();
        })
        .fail((XMLHttpRequest, textStatus, errorMessage) => {
            Notify.error(errorMessage);
            undim();
        });
}

const invalidateGireveEmpContract = (sellerId, contractId) => {
    dim();
    sendDeleteRequest('/admin/roaming/contracts/cpo/' + contractId + '/' + sellerId)
        .done((data) => {
            Notify.success(i18n.t('roamingManagement.ocpi.contract_deleted'));
            showGireveEmpRegisterComponent();
            updateHTMLWithGireveEmpContract([]);
        })
        .fail((XMLHttpRequest, textStatus, errorMessage) => {
            Notify.error(errorMessage);
            undim();
        });
}

export { invalidateGireveEmpContract, loadGireveEMPContract, registerInGireveEMPSystem };
